module.exports = __webpack_public_path__ + "static/media/icons_return.a2286c0e.svg";